import Lottie from 'react-lottie';
import SocialButtons from '../components/SocialButtons';
import animProgrammer from '../lotties/mobile-developer';

export default function Hero(props) {
  const animProgrammerOptions = {
    loop: true,
    autoplay: true,
    animationData: animProgrammer,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const LandingText = () => (
    <div className="mt-3 sm:my-24 lg:my-28 pr-10 sm:pr-5 pl-10">
      <p className="text-4xl lg:text-9xl font-semibold bg-gradient-to-r from-blue-900 to-teal-600 bg-clip-text text-transparent inline-block">
        Hello
      </p>
      <p className="text-lg font-extralight my-4">
        My name is Yusuf Fachroni. I am an experienced mobile programmer with
        expertise in developing intuitive and responsive applications. In
        addition, I have experience in react web and backend development which
        helps me efficiently complete projects and achieve optimal results.
      </p>
      <SocialButtons />
    </div>
  );

  return (
    <section
      ref={props.refs}
      id="home"
      aria-label="Introduction"
      className="bg-[rgba(247,250,251,1)] grid sm:grid-cols-2 w-full pt-16 lg:pt-24"
    >
      <h1 className="sr-only">
        Yusuf Fachroni — Flutter &amp; Mobile Developer
      </h1>
      <div className="hidden sm:block">
        <LandingText />
      </div>
      <div className="p-5 lg:px-10">
        <div className="sm:my-[50%] md:my-[30%] lg:my-[10%]">
          <Lottie
            options={animProgrammerOptions}
            height={'100%'}
            width={'100%'}
          />
        </div>
      </div>
      <div className="sm:hidden">
        <LandingText />
      </div>
    </section>
  );
}
